import {
  isAdditiveLayerSelect,
  nextLayerSelection,
  nextMarqueeSelection,
} from "../creativeTemplates/editor/canvasLayerSelection";

export const VIDEO_EDITOR_SELECTION_MODE = {
  REPLACE: "replace",
  TOGGLE: "toggle",
  ADD: "add",
  CLEAR: "clear",
};

export const toSelectionModifiers = (event) => ({
  ctrlKey: Boolean(event?.ctrlKey),
  metaKey: Boolean(event?.metaKey),
  shiftKey: Boolean(event?.shiftKey),
});

export const getClipSelectionMode = (event) =>
  isAdditiveLayerSelect(event)
    ? VIDEO_EDITOR_SELECTION_MODE.TOGGLE
    : VIDEO_EDITOR_SELECTION_MODE.REPLACE;

const uniqueIds = (ids = []) =>
  [...new Set((Array.isArray(ids) ? ids : []).filter(Boolean))];

export const createEmptyClipSelection = () => ({
  selectedClipIds: [],
  selectedClipId: null,
});

export const normalizeClipSelection = ({
  clipIds = [],
  primaryClipId = null,
  availableIds = null,
} = {}) => {
  const available = availableIds ? new Set(availableIds) : null;
  const selectedClipIds = uniqueIds(clipIds).filter((clipId) =>
    available ? available.has(clipId) : true
  );
  const selectedClipId = selectedClipIds.includes(primaryClipId)
    ? primaryClipId
    : selectedClipIds[selectedClipIds.length - 1] || null;

  return {
    selectedClipIds,
    selectedClipId,
  };
};

export const resolveClipSelection = ({
  currentIds = [],
  clipId = null,
  clipIds = null,
  event,
  mode = VIDEO_EDITOR_SELECTION_MODE.REPLACE,
  preserveMulti = false,
} = {}) => {
  if (mode === VIDEO_EDITOR_SELECTION_MODE.CLEAR || (!clipId && !clipIds?.length)) {
    return createEmptyClipSelection();
  }

  if (Array.isArray(clipIds)) {
    const marquee = nextMarqueeSelection({
      currentIDs: currentIds,
      ids: clipIds,
      event:
        mode === VIDEO_EDITOR_SELECTION_MODE.ADD ||
        mode === VIDEO_EDITOR_SELECTION_MODE.TOGGLE
          ? event || { ctrlKey: true }
          : event,
    });
    return normalizeClipSelection({
      clipIds: marquee.ids,
      primaryClipId: marquee.primary,
    });
  }

  const next = nextLayerSelection({
    currentIDs: currentIds,
    id: clipId,
    event:
      mode === VIDEO_EDITOR_SELECTION_MODE.TOGGLE
        ? event || { ctrlKey: true }
        : event,
    preserveMulti,
  });

  return normalizeClipSelection({
    clipIds: next.ids,
    primaryClipId: next.primary,
  });
};

export const pruneClipSelection = ({ selection, availableIds = [] }) =>
  normalizeClipSelection({
    clipIds: selection?.selectedClipIds,
    primaryClipId: selection?.selectedClipId,
    availableIds,
  });

export const isClipSelected = ({ selectedClipIds = [], clipId }) =>
  Boolean(clipId && selectedClipIds.includes(clipId));

export { isAdditiveLayerSelect };
